import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class SalaryTypeService {
    constructor(private readonly datatask: DataTaskService) {}

    /** Loads a salary type for editing. @datatask 482 */
    public async getSalaryType(params: SalaryTypeParams): Promise<SalaryTypeGet> {
        return (await this.datatask.Post(482, params))[0];
    }

    /** Saves a salary type. @datatask 483 */
    public async saveSalaryType(page: SalaryTypeGet): Promise<SalaryTypeActionResponse> {
        return (await this.datatask.Post(483, page))[0];
    }

    /** Deletes a salary type. @datatask 484 */
    public async deleteSalaryType(params: SalaryTypeParams): Promise<SalaryTypeActionResponse> {
        return (await this.datatask.Post(484, params))[0];
    }

    /** Retrieves the time account impact choices. @datatask 2124 */
    public getImpactTimeAccounts(): Promise<Item[]> {
        return this.datatask.Post(2124);
    }

    /** Retrieves extra quantity type choices. @datatask 3422 */
    public getExtraQuantityTypes(): Promise<ExtraQuantityTypeItem[]> {
        return this.datatask.Post(3422);
    }
}

export interface SalaryTypeParams {
    salarytype_id: string;
}

export interface SalaryTypeActionResponse {
    status_no: string | number;
    status_message: string;
}

export interface ExtraQuantityTypeItem {
    extra_quantity_type_id: string;
    extra_quantity_type_name: string;
    orderby: string;
}

export interface SalaryTypeGet {
    salarytype_id: string;
    salarytype_name: string;
    id_in_salaryprogram: string;
    salarytype_id_paycheck: string;
    unit_no: string;
    absence: '0' | '1';
    absence_paid: '0' | '1';
    absence_legal: '0' | '1';
    overtime: '0' | '1';
    extrapst: string | number;
    donotsplit: '0' | '1';
    transfer_to_paycheck: '0' | '1';
    timeaccount_impact: string;
    is_extra: '0' | '1';
    extra_quantity_type_id: string;
    prod_id: string;
    prod_keyno: string;
    prod_name: string;
    is_new: '0' | '1';
}
